<template>
  <div :id="navId" class="article-image-text-container">
    <div class="article-image-text" :class="classes">
      <div class="imageOne">
        <Picture :images="imageOne" />
      </div>
      <div class="textBox">
        <div v-if="subHeading" class="article-image-text__type">
          {{ subHeading }}
        </div>
        <div v-if="heading" class="heading">{{ heading }}</div>
        <div class="text"><slot name="content" /></div>
      </div>
    </div>
  </div>
</template>

<script>
import Picture from "@/components/Picture.vue";
export default {
  name: "ArticleImageText",
  components: {
    Picture,
  },
  props: {
    navId: {
      type: String,
      default: null,
    },
    imageOne: {
      type: Object,
      default: null,
    },
    subHeading: {
      type: String,
      default: null,
    },
    heading: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
    flip: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      return {
        "article-image-text--flip": this.flip,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.article-image-text-container {
  margin: 0 auto 40px;
  max-width: 1600px;

  @include respond-above(md) {
    padding: 0 20px;
    margin: 0 auto 60px;
  }
}
.article-image-text {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  position: relative;

  &__type {
    color: $color-grey-dark;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.55px;
    margin: 0 0 10px;
    text-align: center;
    text-transform: uppercase;
  }

  &--flip {
    direction: rtl;
  }
}

:deep(h4) {
  margin-bottom: 10px;
}

.heading {
  @include t__editorial-headline-10;
  text-align: center;
  margin-bottom: 10px;
  text-transform: uppercase;
  @include respond-above(md) {
    @include t__editorial-headline-20;
  }
}

.text {
  font-family: $heading-font-family;
  text-align: center;
}

.textBox {
  direction: initial;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0px 50px 0px 50px;
}

:slotted(p) {
  @include t__editorial-body-10;
  margin: 0 0 15px 0;
  @include respond-above(md) {
    @include t__editorial-body-20;
  }
}
</style>
